@if (isLoading) {
  <korviu-loader></korviu-loader>
}
<form [formGroup]="referralForm" class="flex flex-col justify-start">
  <div class="flex justify-between gap-4 mb-4">
    <korviu-input
      type="text"
      label="{{ 'referral.firstName' | translate }}"
      [control]="firstNameControl"
      [errorMessagesUnderField]="firstNameErrors"
      class="w-full"
      [showErrorMessagesUnderField]="true"
    ></korviu-input>
    <korviu-input
      type="text"
      label="{{ 'referral.lastName' | translate }}"
      [control]="lastNameControl"
      [errorMessagesUnderField]="lastNameErrors"
      class="w-full"
      [showErrorMessagesUnderField]="true"
    ></korviu-input>
  </div>
  <div class="flex flex-col mb-4">
    <span class="paragraph-medium medium mb-2">{{ 'referral.contact-method' | translate }}</span>
    <nz-radio-group [formControl]="contactMethodControl">
      <div class="flex gap-6 items-center">
        <label nz-radio nzValue="whatsapp">{{ 'referral.whatsApp' | translate }}</label>
        <label nz-radio nzValue="email">{{ 'profile.email' | translate }}</label>
      </div>
    </nz-radio-group>
  </div>
  <div class="mb-4">
    @if (contactMethodControl?.value === 'email') {
      <korviu-input
        type="text"
        label="{{ 'auth.email' | translate }}"
        [showErrorMessagesUnderField]="true"
        [errorMessagesUnderField]="[{ errorCode: 'email', localizedMessage: 'validation.invalidEmail' }]"
        [control]="emailControl"
      ></korviu-input>
    } @else {
      <korviu-input
        type="phone"
        label="{{ 'referral.phoneNumber' | translate }}"
        maxLength="14"
        class="phone-number-field"
        [control]="phoneNumberControl"
        [phoneNumberPrefixControl]="phoneNumberPrefixControl"
        [removePlusFromPhoneCode]="true"
        [showErrorMessagesUnderField]="true"
        [errorMessagesUnderField]="phoneNumberErrors"
        (input)="onPhoneNumberInput($event)"
      />
    }
  </div>
  <div class="flex flex-col mb-4">
    <span class="paragraph-medium medium mb-2">{{ 'referral.language' | translate }}</span>
    <nz-radio-group [formControl]="languageControl">
      <label nz-radio [nzValue]="'es'" class="mr-4">{{ 'common.spanish' | translate }}</label>
      <label nz-radio [nzValue]="'en'">{{ 'common.english' | translate }}</label>
    </nz-radio-group>
    <span class="flex flex-col mt-8">
      <korviu-textarea
        [control]="messageTemplateControl"
        [spellcheck]="false"
        customClass="referral-message-textarea"
      ></korviu-textarea>
    </span>
  </div>
</form>
